import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';
import {
  getCustomerResponsibilitiesMembersPaginationResult,
  getCustomerResponsibilitiesMembersStateLoading,
} from 'gcs-common/slices/administration/customerResponsibilityMembers/customerResponsibilityMembersSelector';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';

import CustomerResponsibilityMembersTable from '../CustomerResponsibilityMembersTable/CustomerResponsibilityMembersTable';

const CustomerResponsibilityMembersOverview = () => {
  const customerResponsibilityMembersLoading = useSelector(getCustomerResponsibilitiesMembersStateLoading);
  const customerResponsibilityMembersPagination = useSelector(getCustomerResponsibilitiesMembersPaginationResult);

  return (
    <>
      <div className={styles.headerRow}>
        <div className={styles.inputHeaderText}>
          Verantwortlichkeiten ({customerResponsibilityMembersPagination?.total})
        </div>
        {customerResponsibilityMembersLoading && <LoadingIndicator padding="0" />}
      </div>
      <CustomerResponsibilityMembersTable filter={[]} />
    </>
  );
};

export default CustomerResponsibilityMembersOverview;
